/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/nocontent/nocontent_styles';



/* ========== ~~~~~~~~~~ EMBED NO CONTENT ~~~~~~~~~~ ========== */
const NoContent = (props) => {
    const renderText = () =>{
        return props.contents ? <p>This Embed has <strong>no</strong> live content</p> : <p>This Embed has <strong>no</strong> content</p>;
    };
    return(
        <div className={`noContent ${props.classes.noContent}`}>
            {renderText()}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(NoContent);
